/**
 * Returns the logo link target for the site header:
 *   - Public view → /draganddrop
 *   - Any /draganddrop/* or /matching-dashboard/* path → /draganddrop
 *   - Everywhere else → /
 */
export default function getLogoTarget({ pathname, publicView }) {
    if (publicView) {
        return '/draganddrop';
    }
    if (typeof pathname !== 'string') {
        return '/';
    }
    if (pathname === '/draganddrop' || pathname.startsWith('/draganddrop/')) {
        return '/draganddrop';
    }
    if (pathname.startsWith('/matching-dashboard/')) {
        return '/draganddrop';
    }
    return '/';
}
